import React, { useState, useEffect, useCallback, useMemo } from 'react';
import OnlineStoreRightsNa from 'elem/compPage/stream-series-plug-in-solar-battery/pages/product/components/OnlineStoreRightsNa';

const OnlineStoreRightsA: React.FC = () => {
    return <OnlineStoreRightsNa />;
};

export default OnlineStoreRightsA;
